import globalFrame from '../../util/globalFrame';
import globalResize from '../../util/globalResize';

export class BaseComponent {
  constructor(el) {
    this.DOM = {};
    this.DOM.el = el;
    this.init();
  }
  init() {
    if (this.onResize) {
      this.handlerResize = (e) => this.onResize(e);
      globalResize.addEvent(this.handlerResize);
    }
    if (this.onClick) {
      this.handlerClick = (e) => this.onClick(e);
      this.DOM.el.addEventListener('click', this.handlerClick);
    }
    if (this.onMouseenter) {
      this.handlerMouseenter = (e) => this.onMouseenter(e);
      this.DOM.el.addEventListener('pointerenter', this.handlerMouseenter);
    }
    if (this.onMousemove) {
      this.handlerMousemove = (e) => this.onMousemove(e);
      this.DOM.el.addEventListener('pointermove', this.handlerMousemove);
    }
    if (this.onMouseleave) {
      this.handlerMouseleave = (e) => this.onMouseleave(e);
      this.DOM.el.addEventListener('pointerleave', this.handlerMouseleave);
    }
    if (this.onTick) this.tick = (e) => this.onTick(e);
  }
  playTick() {
    if (this.tick) {
      globalFrame.addEvent(this.tick);
    } else {
      console.error('not found.onTick Function');
    }
  }
  pauseTick() {
    if (this.tick) {
      globalFrame.removeEvent(this.tick);
    } else {
      console.error('not found.onTick Function');
    }
  }
  dispose() {
    if (this.onResize) {
      globalResize.removeEvent(this.handlerResize);
    }
    if (this.onClick) {
      this.DOM.el.removeEventListener('click', this.handlerClick);
    }
    if (this.onMouseenter) {
      this.DOM.el.removeEventListener('pointerenter', this.handlerMouseenter);
    }
    if (this.onMousemove) {
      this.DOM.el.removeEventListener('pointermove', this.handlerMousemove);
    }
    if (this.onMouseleave) {
      this.DOM.el.removeEventListener('pointermove', this.handlerMouseleave);
    }
    if (this.onTick) {
      globalFrame.pauseTick(this.tick);
    }
    if (this.onDispose) {
      this.onDispose();
    }
  }
  // onInit() {
  //   // 初期化時に書く
  // }
  // onResize() {
  //   // リサイズ時の処理を書く
  // }
  // onClick(e) {
  //   // クリック時の処理を書く
  // }
  // onMouseenter(e) {
  //   // マウスカーソルが入った時の処理を書く
  // }
  // onMousemove(e) {}
  // onMouseleave(e) {}
  // onTick(e) {}
  // onDispose(e) {}
}
